<template>
  <v-form ref="form" v-model="validForm">
    <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="align-end">
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'surname'">{{ bookData.surnameField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'surname'"
            v-model="value.lastName"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            required
            :rules="nameRules"
          />
        </div>
      </v-col>

      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'name'">{{ bookData.nameField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'name'"
            v-model="value.firstName"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            :rules="nameRules"
          />
        </div>
      </v-col>
      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'patronymic'">{{ bookData.patronymicField }}</label>
          <v-text-field
            class="mt-4 text-field"
            :id="'patronymic'"
            v-model="value.patronymic"
            outlined
            dense
            clearable
            color="#FFA903"
            flat
            style="border-radius: 0 !important;"
            :rules="nameRules"
          />
        </div>
      </v-col>
    </v-row>
    <v-row :no-gutters="$vuetify.breakpoint.smAndDown" class="align-end">
      <!--      <v-col v-if="!short" cols="12" class="col-md-4">-->
      <!--        <div class="form-input">-->
      <!--          <label :for="'tel'">{{ bookData.numberField }}</label>-->
      <!--          <v-text-field-->
      <!--            class="mt-4 text-field"-->
      <!--            type="tel"-->
      <!--            :id="'tel'"-->
      <!--            v-model="value.phone"-->
      <!--            aria-invalid="false"-->
      <!--            aria-required="true"-->
      <!--            outlined-->
      <!--            dense-->
      <!--            clearable-->
      <!--            color="#FFA903"-->
      <!--            flat-->
      <!--            style="border-radius: 0 !important;"-->
      <!--            required-->
      <!--            :rules="telRules"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </v-col>-->

      <v-col cols="12" class="col-md-4">
        <div class="form-input">
          <label :for="'date'">{{ bookData.birthdayField }}</label>
          <v-menu max-width="290" close-on-content-click>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :id="'date'"
                :value="value.birthday"
                clearable
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="value.birthday = null"
                class="mt-4 text-field"
                outlined
                dense
                color="#FFA903"
                flat
                append-icon="mdi-calendar"
                style="border-radius: 0 !important;"
                required
                :rules="nameRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="value.birthday"
              :first-day-of-week="1"
              color="#FFA903"
              locale="ru-RU"
            ></v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <!--      <v-col v-if="!short" cols="12" class="col-md-4">-->
      <!--        <div class="form-input">-->
      <!--          <label :for="'birthCertificateNumber'">{{-->
      <!--            bookData.birthCertificateField-->
      <!--          }}</label>-->
      <!--          <v-text-field-->
      <!--            class="mt-4 text-field"-->
      <!--            :id="'birthCertificateNumber'"-->
      <!--            v-model="value.birthCertificate"-->
      <!--            outlined-->
      <!--            dense-->
      <!--            clearable-->
      <!--            color="#FFA903"-->
      <!--            flat-->
      <!--            style="border-radius: 0 !important;"-->
      <!--            required-->
      <!--          />-->
      <!--        </div>-->
      <!--      </v-col>-->
    </v-row>
    <v-btn
      class="main-btn rounded-0 text-capitalize mt-7"
      @click="submit"
      :disabled="!validForm"
      color="#FFA903"
    >
      {{ bookData.formSubmitTitle }}
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: "ChildForm",
  props: ["value", "short"],
  computed: {
    bookData() {
      return this.$t("book");
    }
  },
  data: () => ({
    validForm: false,
    nameRules: [v => !!v || "Enter field"],
    telRules: [v => !!v || "Enter phone number"]
  }),
  methods: {
    submit() {
      const form = this.$refs.form;
      if (form.validate()) this.$emit("submitChildrenForm", this.value);
    }
  }
};
</script>

<style scoped></style>
